import { Injectable } from '@angular/core';
import { Errors, Labels } from './def/common-content';
import { Title } from '@angular/platform-browser';
import {
  Router,
  Event,
  NavigationStart,
  NavigationEnd,
  ActivatedRoute
} from '@angular/router';
import { PageUrl, PageTitle } from '@tmhcc-ng-lib/models';
@Injectable()
export class CommonContentService {
  constructor(private titleService: Title, public router: Router) {}

  private errors: Errors;
  private labels: Labels;
  artisan = 'Artisan ::';

  getErrors(): Errors {
    if (!this.errors) {
      // replace contenct service here
      this.errors = this.staticErrors;
    }
    return this.errors;
  }

  getLabels(): Labels {
    if (!this.labels) {
      //replace contenct service here
      this.labels = this.staticLabels;
    }

    return;
  }

  setPageTitle() {
    let urlpage = this.router.url.split('/');
    let path = urlpage.pop();
    let pagetitle = path.split('-').pop();

    switch (pagetitle) {
      case PageUrl.Dashboard:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.Dashboard);
        break;
      case PageUrl.NewsFeed:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.NewsFeed);
        break;
      case PageUrl.Insured:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.Insured);
        break;
      case PageUrl.Owner:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.Owner);
        break;
      case PageUrl.Ratings:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.Ratings);
        break;
      case PageUrl.Liability:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.Liability);
        break;
      case PageUrl.ExcessCoverage:
        this.titleService.setTitle(
          this.artisan + ' ' + PageTitle.ExcessCoverage
        );
        break;
      case PageUrl.Property:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.Property);
        break;
      case PageUrl.GeneralQuestion:
        this.titleService.setTitle(
          this.artisan + ' ' + PageTitle.GeneralQuestion
        );
        break;
      case PageUrl.CoverageQuestion:
        this.titleService.setTitle(
          this.artisan + ' ' + PageTitle.CoverageQuestion
        );
        break;
      case PageUrl.Document:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.Document);
        break;
      case PageUrl.RenewalReview:
        this.titleService.setTitle(
          this.artisan + ' ' + PageTitle.RenewalReview
        );
        break;
      case PageUrl.PolicySnapshot:
        this.titleService.setTitle(
          this.artisan + ' ' + PageTitle.PolicySnapshot
        );
        break;
      case PageUrl.VerifyCoverage:
        this.titleService.setTitle(
          this.artisan + ' ' + PageTitle.VerifyCoverage
        );
        break;
      case PageUrl.VerifyPolicy:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.VerifyPolicy);
        break;
      case PageUrl.ActionItems:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.ActionItems);
        break;
      case PageUrl.Coverages:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.Coverages);
        break;
      case PageUrl.Policy:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.Policy);
        break;
      case PageUrl.Jobsite:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.Jobsite);
        break;
      case PageUrl.Additional:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.Additional);
        break;
      case PageUrl.Automobile:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.Automobile);
        break;
      case PageUrl.Employee:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.Employee);
        break;
      case PageUrl.Employer:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.Employer);
        break;
      case PageUrl.Losspayee:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.Losspayee);
        break;
      case PageUrl.BoundPolicy:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.BoundPolicy);
        break;
      case PageUrl.EditAddress:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.EditAddress);
        break;
      case PageUrl.ReviewAddress:
        this.titleService.setTitle(
          this.artisan + ' ' + PageTitle.ReviewAddress
        );
        break;
      case PageUrl.PayrollReciept:
        this.titleService.setTitle(
          this.artisan + ' ' + PageTitle.PayrollReciept
        );
        break;
      case PageUrl.ReviewSubmit:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.ReviewSubmit);
        break;
      case PageUrl.Classification:
        this.titleService.setTitle(
          this.artisan + ' ' + PageTitle.Classification
        );
        break;
      case PageUrl.ContactUs:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.ContactUs);
        break;
      case PageUrl.Request:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.Request);
        break;
      case PageUrl.ThankYou:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.ThankYou);
        break;
      case PageUrl.Decline:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.Decline);
        break;
      case PageUrl.Equipment:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.Equipment);
        break;
      case PageUrl.EnPolicy:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.EnPolicy);
        break;
      case PageUrl.EnCoverage:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.EnCoverage);
        break;
      case PageUrl.EnPolicyInfo:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.EnPolicyInfo);
        break;
      case PageUrl.AdInsured:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.AdInsured);
        break;
      case PageUrl.Submit:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.Submit);
        break;
      case PageUrl.AddForms:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.AddForms);
        break;
      default:
        this.titleService.setTitle(this.artisan + ' ' + PageTitle.Dashboard);
    }
  }
  // replace this when content is pulled from sitecore or content delivery system
  private readonly staticErrors: Errors = {
    InvalidLossDate: 'Invalid data returned from service. Invalid loss date.'
  };

  private readonly staticLabels: Labels = {
    Welcome: 'Welcome'
  };
}
